import { $api } from "@/kibi/core/utils/api";
import type {
  PaginatedResponse,
  QueryOptions,
} from "@/kibi/core/utils/pagination_types";
import type { InjectionKey } from "vue";
import type { AuditLogDTO } from "../models/audit_log_model";

export interface AuditLogDataSource {
  getAuditLogs(
    options: QueryOptions,
  ): Promise<PaginatedResponse<AuditLogDTO[]>>;
  getAllAuditLogs(
    options: QueryOptions,
  ): Promise<PaginatedResponse<AuditLogDTO[]>>;
  getAuditLogsByUserId(
    userId: string,
    options: QueryOptions,
  ): Promise<PaginatedResponse<AuditLogDTO[]>>;
}

export const auditLogDataSourceKey: InjectionKey<AuditLogDataSource> =
  Symbol("AuditLogDataSource");

export class AuditLogDataSourceImpl implements AuditLogDataSource {
  async getAuditLogs(
    options: QueryOptions,
  ): Promise<PaginatedResponse<AuditLogDTO[]>> {
    const response = await $api<PaginatedResponse<AuditLogDTO[]>>(
      "/audit-logs",
      {
        method: "GET",
        params: options,
      },
    );
    return response;
  }

  async getAllAuditLogs(
    options: QueryOptions,
  ): Promise<PaginatedResponse<AuditLogDTO[]>> {
    const response = await $api<PaginatedResponse<AuditLogDTO[]>>(
      "/audit-logs/all",
      {
        method: "GET",
        params: options,
      },
    );
    return response;
  }

  async getAuditLogsByUserId(
    userId: string,
    options: QueryOptions,
  ): Promise<PaginatedResponse<AuditLogDTO[]>> {
    const response = await $api<PaginatedResponse<AuditLogDTO[]>>(
      `/audit-logs/users/${userId}`,
      {
        method: "GET",
        params: options,
      },
    );
    return response;
  }
}
